import styled from "styled-components";

const Transit = styled.div`
  display: flex;

  flex-grow: 1;
  position: relative;
  gap: 0.5rem;
  align-items: center;
  justify-content: center;
  margin-top: 2px;
  z-index: 1;
  margin: 0 8px;
  box-sizing: border-box;

  img {
    position: absolute;
    padding: 4px;
    z-index: 100;
    // height: 16px;
    background-color: ${({ theme }) => theme.colors.journeySectionBackground};
    z-index: 100;
  }

  &::before {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    width: 100%;
    height: 1px;
    background-color: ${({ theme }) => theme.colors.base5};
  }
`;

export default Transit;
